// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7e1c4b17","239":"ba33802d","453":"50e315d5","455":"845e63c6"}[chunkId] + ".chunk.js";
};